


































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { WorkerListModule } from '@/store/modules/workerList';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import BranchDto from '@/models/Branches/BranchDto';


@Component({
    name: 'WorkerListSearchCriteria'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public locationSearch: any = null;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      await WorkerListModule.getLocationsForSearchOptions();
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.skills.length === 0) {
        await AgencySettingsModule.getSkills();
      }
      if (AgencySettingsModule.qualifications.length === 0) {
        await AgencySettingsModule.getQualifications();
      }
      if (AgencySettingsModule.branches.length === 0) {
        await AgencySettingsModule.getBranches();
      }
    }
  }

  get searchOptions() {
      return WorkerListModule.workerSearchViewModel;
  }
  
  get positions() {
    return AgencySettingsModule.positions;
  }

  get skills() {
    return AgencySettingsModule.skills;
  }

  get qualifications() {
    return AgencySettingsModule.qualifications;
  }

  @Watch('searchOptions.selectedBranch')
  onSelectedBranchChanged(val: BranchDto, oldVal: BranchDto) {
    if (!val) {
      this.searchOptions.selectedDesk = null;
    }
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get desks() {
    if (this.searchOptions.selectedBranch) {
      return this.searchOptions.selectedBranch.desks;
    }
    return [];
  }

  get loading() {
    return WorkerListModule.loading;
  }

  async search() {
    this.dialog = false;
    await WorkerListModule.searchWorkers()
  }
}
